"use client";

import { Particles, ScrollProgress } from "./Effects";

export default function ClientEffects() {
  return (
    <>
      <Particles />
      <ScrollProgress />
    </>
  );
}
